import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import Spinner from "../../../components/Spinner/Spinner";
import CarouselCard from "./carouselCard";

class CarouselForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carousel: {
        imgUrl: "",
        imgTitle: "",
        redirectUrl: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleDeleteCarousel = this.handleDeleteCarousel.bind(this);
  }
 
  componentDidMount() {
    this.props.fetchCarouselData();
  }

  handleChange(e) {
    const { name, value } = e.target;
    let carousel = { ...this.state.carousel };
    carousel[name] = value;
    this.setState({
      carousel: carousel,
    });
  }

  handleUpload(e) {
    let carousel = { ...this.state.carousel };
    carousel[e.target.name] = e.target.files[0];
    this.setState({ carousel: carousel });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    let carousel = { ...this.state.carousel };
    // let brand = this.props.brands.filter(
    //   (brand) => carousel.brandId == brand.id
    // )[0];
    // let brandName = brand["name"];
    // carousel["brandName"] = brandName;
    // this.setState({ carousel });
    this.props.onAddCarousel(carousel);
  }

  handleEditSubmit(e, editedCarousel) {
    e.preventDefault();
    let carousel = editedCarousel;
    if (carousel) {
      //   let brand = this.props.brands.filter(
      //     (brand) => carousel.brandId == brand.id
      //   )[0];
      //   let brandName = brand["name"];
      //   carousel["brand"] = brandName;
      this.props.onEditCarousel(carousel, this.props.carousel);
    } else {
      alert("carousel is null.");
    }
  }

  handleDeleteCarousel(e, carousel) {
    e.preventDefault();
    this.props.onDeleteCarousel(carousel);
  }

  render() {
    if (this.props.loading) {
      return <Spinner />;
    }

    let carousel = this.props.carousel;
    let carouselList =
      carousel &&
      carousel.map((carousel, index) => (
        <CarouselCard
          key={index}
          carousel={carousel}
          id={carousel.id}
          handleEditSubmit={(e, editedCarousel) =>
            this.handleEditSubmit(e, editedCarousel)
          }
          handleDeleteCarousel={this.handleDeleteCarousel}
          carouselBtnLoading={this.props.carouselBtnLoading}
          deleteBtnLoading={this.props.deleteBtnLoading}
          // isAdmin={this.props.isAdmin}
        />
      ));

    return (
      <React.Fragment>
        <h3 className="text-center">Carousel Management</h3>
        <hr />
        <form onSubmit={this.handleFormSubmit}>
          <div className="row mx-4">
            <div class="form-group col-md-3">
              <label for="imagetitle">Enter Title</label>
              <input
                name="imgTitle"
                type="text"
                id="imagetitle"
                className="form-control"
                value={this.state.carousel.imgTitle}
                onChange={this.handleChange}
                placeholder="Enter Image Title"
                required
              />
            </div>
            <div class="form-group col-md-3">
              <label for="imageurlbrand">Upload Image</label>
              <input
                name="imgUrl"
                type="file"
                id="imageurlbrand"
                className="form-control"
                onChange={this.handleUpload}
                accept=".png,.jpeg, .jpg, .webp"
                required
              />
            </div>
            <div class="form-group col-md-4">
              <label for="redirect">Redirect Url</label>
              <input
                name="redirectUrl"
                type="text"
                id="redirect"
                className="form-control"
                placeholder="Enter Redirect Url"
                onChange={this.handleChange}
                value={this.state.carousel.redirectUrl}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-sm btn-success d-inline"
              style={{ marginTop: "2.2rem", marginBottom: "2rem" }}
              disabled={this.props.addBtnLoading}
            >
              {this.props.addBtnLoading ? "Saving" : "Save"}
            </button>
          </div>
        </form>
        <hr />
        <div className="row m-4">{carouselList}</div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.carouselData.loading,
    carousel: state.carouselData.carouselData,
    addBtnLoading: state.carouselData.addBtnLoading,
    carouselBtnLoading: state.carouselData.carouselBtnLoading,
    deleteBtnLoading: state.carouselData.deleteBtnLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCarouselData: () => dispatch(actions.fetchCarouselData()),
    onAddCarousel: (carousel) => dispatch(actions.onAddCarousel(carousel)),
    onEditCarousel: (editedCarousel, oldCarouselArray) =>
      dispatch(actions.onEditCarousel(editedCarousel, oldCarouselArray)),
    onDeleteCarousel: (carouselId) =>
      dispatch(actions.onDeleteCarousel(carouselId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(CarouselForm, Axios));
